import qualityEventsHelpers, { QualityEventContext } from '../quality-events.helpers';

type QualityReportContext = {
    qualityBadge?: number;
    assessmentDate?: string;
};

type DimensionAccordionArgs = {
    materialId?: number;
    eventType: string;
    isExpanded: boolean;
    suggestions: number;
};

export const QUALITY_REPORT_PAGE_EVENTS = {
    viewQualityReport(material: Material | undefined, { qualityBadge, assessmentDate }: QualityReportContext) {
        qualityEventsHelpers.track({
            ...(material ? qualityEventsHelpers.extractMaterialsData(material) : {}),
            type: 'view_quality_report',
            extra: JSON.stringify({ quality_badge: qualityBadge, assessment_date: assessmentDate })
        });
    },
    clickLearnAboutQuality(materialId: number | undefined, { qualityBadge, assessmentDate }: QualityReportContext) {
        qualityEventsHelpers.track({
            type: 'click_learn_about_quality',
            item_id: materialId,
            extra: JSON.stringify({ quality_badge: qualityBadge, assessment_date: assessmentDate })
        });
    },
    clickUpdateMyMaterial(materialId: number | undefined, { qualityBadge, assessmentDate }: QualityReportContext) {
        qualityEventsHelpers.track({
            type: 'click_update_my_material',
            item_id: materialId,
            extra: JSON.stringify({ quality_badge: qualityBadge, assessment_date: assessmentDate })
        });
    },
    clickDimensionAccordion({ materialId, eventType, isExpanded, suggestions }: DimensionAccordionArgs) {
        qualityEventsHelpers.track({
            type: eventType,
            item_id: materialId,
            extra: JSON.stringify({ action: isExpanded ? 'expand' : 'collapse', suggestions })
        });
    },
    submitReportFeedback(
        materialId: number | undefined,
        feedbackHelpful: 'yes' | 'no',
        comment: string,
        context?: QualityEventContext
    ) {
        return qualityEventsHelpers.track(
            {
                type: 'submit_report_feedback',
                item_id: materialId,
                extra: JSON.stringify({ feedback_helpful: feedbackHelpful, comment })
            },
            context
        );
    },
    clickDownloadReport(materialId: number | undefined, assessmentDate?: string) {
        qualityEventsHelpers.track({
            type: 'click_download_report',
            item_id: materialId,
            extra: JSON.stringify({ assessment_date: assessmentDate })
        });
    },
    clickViewPrevReport(materialId: number | undefined, assessmentDate: string | undefined, positionInHistory: number) {
        qualityEventsHelpers.track({
            type: 'click_view_prev_report',
            item_id: materialId,
            extra: JSON.stringify({ assessment_date: assessmentDate, position_in_history: positionInHistory })
        });
    },
    clickBackToMaterials(materialId: number | undefined) {
        qualityEventsHelpers.track({
            type: 'click_back_to_materials',
            item_id: materialId
        });
    },
    viewPageMaxScroll(maxScrollDepth: number, materialId?: number) {
        qualityEventsHelpers.trackAndForget({
            type: 'view_page_max_scroll',
            item_id: materialId,
            extra: JSON.stringify({ max_scroll_depth: maxScrollDepth })
        });
    },
    timeToLoad(materialId: number | undefined, seconds: number) {
        qualityEventsHelpers.trackAndForget({
            type: 'Time_to_load',
            item_id: materialId,
            extra: JSON.stringify({ seconds })
        });
    },
    errorQualityAssessmentLoad(materialId: number | undefined, errorType: string) {
        qualityEventsHelpers.track({
            type: 'error_quality_assessment_load',
            item_id: materialId,
            extra: JSON.stringify({ error_type: errorType })
        });
    }
};
